var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNegative(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "459.42001pt",
    height: "459.41998pt",
    viewBox: "0 0 459.42001 459.41998",
    id: "svg157",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs71"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g155",
    transform: "translate(-124.50649,-109.03253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 354.21649,109.03253 c -126.84,0 -229.71,102.87 -229.71,229.71 0,126.84 102.87,229.71 229.71,229.71 126.84,0 229.71,-102.87 229.71,-229.71 0,-126.84 -102.87,-229.71 -229.71,-229.71 z m 142.86,229.71 c 0,15.457 -12.543,28 -28,28 h -229.71 c -15.457,0 -28,-12.543 -28,-28 0,-15.457 12.543,-28 28,-28 h 229.71 c 15.457,0 28,12.543 28,28 z",
    id: "path73"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNegative);
export default __webpack_public_path__ + "static/media/Icon Negative.9d0aaa7c53434d8dc8188f74d238a93f.svg";
export { ForwardRef as ReactComponent };